export default {
	getDecks: ({ decks }) => decks,
	getTypesByDeckId: ({ decks }) => (selectedId) => decks.filter(deck => deck.id === selectedId),
};


// WEBPACK FOOTER //
// ./src/store/decks/getters.js